// Formatos de extrato bancário que o backend sabe ler.
//
// Fonte única para o `accept` de TODOS os seletores de ficheiro de extrato —
// há três (o modal global, o painel de conciliação e o separador de extrato),
// e enquanto cada um tinha a sua lista, dois deles ficaram presos em
// ".csv,.txt,.xlsx,.xls,.pdf" e escondiam do utilizador os formatos padrão
// (OFX/MT940/CAMT/QIF) que o parser já aceitava.
//
// Tem de acompanhar src/core/extrato_parser.py::parse_extrato_auto. O backend
// decide o formato pelo CONTEÚDO, não pela extensão — isto aqui é só para o
// diálogo do sistema operativo não esconder ficheiros válidos.
export const ACCEPT_EXTRATO =
  ".xlsx,.xls,.csv,.txt,.pdf,.htm,.html,.ofx,.qfx,.qif,.xml,.sta,.mt940,.940";

// Texto curto para mostrar por baixo da zona de upload.
export const LEGENDA_FORMATOS_EXTRATO =
  "Excel · CSV · PDF · HTML · OFX · MT940 · CAMT.053 · QIF";

/**
 * Constrói a mensagem de erro de uma importação de extrato falhada.
 *
 * O 400 de "não consegui ler este ficheiro" traz três campos (ver
 * api.py::importar_arquivo): `msg`, `motivo` (o que o parser detetou e porque
 * é que parou) e `formatos_suportados`. Os três sítios que fazem upload
 * mostravam só `msg`, o que dava sempre a mesma frase genérica e não ajudava
 * ninguém a perceber o que corrigir.
 */
export function mensagemErroImportacao(detail: unknown, omissao = "Erro ao importar o ficheiro."): string {
  if (typeof detail === "string") return detail;
  const d = detail as { msg?: string; motivo?: string; formatos_suportados?: string } | null;
  if (!d) return omissao;
  return [
    d.msg,
    d.motivo,
    d.formatos_suportados && `Formatos aceites: ${d.formatos_suportados}`,
  ].filter(Boolean).join(" ") || omissao;
}
